export default {"src":"/_next/static/image/public/images/flags/flag_508.6daf765fb8a2fed59177329f676a3631.svg","height":16,"width":24};